
export const setTrails = (state, trails) => {
    state.trails = trails
    state.loading = false
}

export const setCurrentTrail = (state, trail) => {
    state.currentTrail = trail
    state.loading = false
}

export const setLoading = (state, loading) => {
    state.loading = loading
}
